/**
 * Cypress test-mode bypasses (mocked auth, skipped onboarding/admin guards) are gated
 * behind a build-time flag so they can never run in a deployed production bundle.
 *
 * `VUE_APP_ALLOW_TEST_MODE` is set only by the `serve:*` scripts (local + CI test
 * servers). The `build:*` scripts that produce deployed artifacts omit it, so this
 * resolves to a constant `false` there and the `window.__CYPRESS_TEST_MODE__` runtime
 * flag has no effect — closing the test-backdoor escalation path.
 */
const TEST_MODE_BUILD_ALLOWED = process.env.VUE_APP_ALLOW_TEST_MODE === "true";

export const isTestModeAllowed = () =>
  TEST_MODE_BUILD_ALLOWED &&
  typeof window !== "undefined" &&
  window.__CYPRESS_TEST_MODE__ === true;
